import { defineStore } from 'pinia'
import localAppSetting from '@/static/json/appSetting.json'
import { envConfig } from '@/utils/env'

// COS CDN 远程配置地址  'https://easyplay-static.cogaming.top/wx/mp-system/app-setting-conf/appSetting.json'
const REMOTE_SETTING_URL = envConfig.remoteAppSettingUrl

interface AppSettingData {
  defaults: Record<string, boolean>
  overrides: Record<string, Record<string, boolean>>
}

// const {
//   miniProgram: { envVersion },
// } = uni.getAccountInfoSync()
const envVersion = typeof uni.getAccountInfoSync === 'function'
  ? uni.getAccountInfoSync().miniProgram.envVersion
  : undefined

export const useAppSettingStore = defineStore(
  'appSetting',
  () => {
    const settingData = ref<AppSettingData>(localAppSetting as unknown as AppSettingData)
    const isRemoteLoaded = ref(false)

    /** 从远程存储桶拉取配置 */
    function fetchRemoteSetting() {
      uni.request({
        url: REMOTE_SETTING_URL,
        method: 'GET',
        success: (res) => {
          if (res.statusCode === 200 && res.data) {
            settingData.value = res.data as AppSettingData
            isRemoteLoaded.value = true
          }
        },
        fail: (err) => {
          console.warn('远程appSetting拉取失败，使用本地配置', err)
        },
      })
    }

    /**
     * 获取功能开关配置
     * 先返回本地 static/json/appSetting.json 的数据
     * 同时从远程存储桶拉取，拉取成功后自动更新为远程数据
     */
    function getAppSetting(): AppSettingData {
      if (!isRemoteLoaded.value) {
        fetchRemoteSetting()
      }
      return settingData.value
    }

    /**
     * 获取指定功能的开关状态（扁平 key）
     * @param key 功能键，格式为 "页面.功能名"，如 "login.showAdminLogin"
     * @returns 开关状态，未配置默认返回 true
     */
    function getFeature(key: string): boolean {
      const override = settingData.value?.overrides?.[envVersion]?.[key]
      if (override !== undefined)
        return override
      return settingData.value?.defaults?.[key] ?? true
    }

    return {
      settingData,
      isRemoteLoaded,
      getAppSetting,
      getFeature,
      fetchRemoteSetting,
    }
  },
)
